import React from 'react'
import Dropzone from 'react-dropzone'
import PhotoUploader from './PhotoUploader'
import PropTypes from 'prop-types'
import './PhotoSelector.scss'
import PhotoIcon from '../../../assets/codicons/picture.svg'

const ACCEPTED_FILE_TYPES = [
  'image/jpg',
  'image/jpeg',
  'image/gif',
  'image/png',
  'image/svg'
]

class PhotoSelector extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      file: null,
      showUploader: false
    }

    this.handleOnDrop = this.handleOnDrop.bind(this)
  }

  handleOnDrop (acceptedFiles) {
    this.setState({ file: acceptedFiles[0], showUploader: true })
  }

  render () {
    let error
    if (this.state.error) {
      error = (
        <div className='PhotoSelector__error'>
          <i className='fa fa-exclamation-triangle'>{this.state.error}</i>
        </div>
      )
    }

    let hint
    if (this.state.hint) {
      hint = <p className='PhotoSelector__hint'>{this.state.hint}</p>
    }

    return (
      <Dropzone onDrop={this.handleOnDrop} accept={ACCEPTED_FILE_TYPES}>
        {({ getRootProps, getInputProps }) => {
          let photoSelectorClass = 'PhotoSelector'
          if (this.props.minimal) {
            photoSelectorClass += ' PhotoSelector--minimal'
          }
          if (this.props.transparent) {
            photoSelectorClass += ' PhotoSelector--transparent'
          }

          let notMinimalSection
          if (!this.props.minimal) {
            notMinimalSection = (
              <div>
                <div className='hidden-xs hidden-sm'>
                  <button className='btn btn-file alo-button'>
                    {this.state.loading
                      ? 'Processing...'
                      : 'Select a photo from your computer'}
                  </button>
                </div>
                <div className='visible-xs'>
                  <button className='btn btn-file alo-button'>
                    {this.state.loading
                      ? 'Processing...'
                      : 'Select from device'}
                  </button>
                </div>
                <div className='visible-sm'>
                  <button className='btn btn-file alo-button'>
                    {this.state.loading
                      ? 'Processing...'
                      : 'Select a photo from your device'}
                  </button>
                </div>
              </div>
            )
          }

          return (
            <React.Fragment>
              <div className={photoSelectorClass} {...getRootProps()}>
                <input {...getInputProps()} />
                <div className='PhotoSelector__editIcon'>
                  <PhotoIcon />
                </div>
                {notMinimalSection}
                {error}
                {hint}
              </div>
              <PhotoUploader
                show={this.state.showUploader}
                file={this.state.file}
                {...this.props}
                onUploaded={this.props.onUploaded}
                onHide={() => {
                  this.setState({ showUploader: false })
                }}
              />
            </React.Fragment>
          )
        }}
      </Dropzone>
    )
  }
}

PhotoSelector.propTypes = {
  modifying: PropTypes.bool,
  photoType: PropTypes.string,
  attachedObj: PropTypes.object,
  onUploaded: PropTypes.func,
  transparent: PropTypes.bool,
  minimal: PropTypes.bool
}

export default PhotoSelector
